import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { CtDocument, CtPage } from '../../../model/ct-batch-model';
import { PageImageService } from '../../../batch-api/page-image.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { DocumentClassLabelPipe } from '../../../document-classes/document-class-pipes';
import { TooltipOnContentOverflowDirective } from '@ps-gui/shared-core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  BehandlerAssignmentData,
  BehandlerAssignmentService,
} from '@ps-gui/shared-document-preview';

@Component({
  selector: 'ct-shared-preview-document-thumbnail',
  imports: [
    NgClass,
    NgTemplateOutlet,
    ProgressSpinner,
    DocumentClassLabelPipe,
    TooltipOnContentOverflowDirective,
    NgOptimizedImage,
  ],
  templateUrl: './preview-document-thumbnail.component.html',
  styleUrl: './preview-document-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewDocumentThumbnailComponent implements OnInit {
  readonly typeThumbnail = input.required<CtPage>();
  readonly selected = input.required<boolean>();
  readonly document = input.required<CtDocument>();

  readonly documentLabelTemplate = input<TemplateRef<{ $implicit: CtDocument }>>();
  readonly documentThumbnailOverlayTemplate = input<TemplateRef<{ $implicit: CtDocument }>>();

  protected readonly label = viewChild<ElementRef>('labelElement');

  protected readonly pageImageService = inject(PageImageService);
  private readonly behandlerAssignmentService = inject(BehandlerAssignmentService);

  protected readonly behandlerAssignmentData = signal<BehandlerAssignmentData | undefined>(
    undefined,
  );

  constructor() {
    this.behandlerAssignmentService.behandlerAssignmentChanged
      .pipe(takeUntilDestroyed())
      .subscribe((documentId) => {
        if (documentId === this.document().id) {
          this.updateBehandlerAssignmentData();
        }
      });
  }

  ngOnInit() {
    this.updateBehandlerAssignmentData();
  }

  private updateBehandlerAssignmentData() {
    this.behandlerAssignmentData.set(this.document().behandlerAssignmentData);
  }
}
